// Central permission map for frontend gating.

const PERMISSIONS = [
  { key: 'dashboard:view', label: 'Ver dashboard' },
  { key: 'reports:view', label: 'Ver reportes' },
  { key: 'conversion:view', label: 'Ver reportes conversión' },
  { key: 'conversion:capture', label: 'Capturar reportes de conversión' },
  { key: 'conversion:analytics', label: 'Ver análisis y gráficas de producción' },
  { key: 'conversion:reopen', label: 'Reabrir reportes cerrados de conversión' },
  { key: 'conversion:deleteReport', label: 'Borrar reportes de conversión' },
  { key: 'conversion:employees', label: 'Ver y gestionar empleados de conversión' },
  { key: 'conversion:ordersdata', label: 'Gestionar Orders Data de conversión' },
  { key: 'conversion:reportespdf', label: 'Ver y generar reportes PDF de conversión' },
  { key: 'conversion:automatic_report_viewanduse', label: 'Ver y usar reportes programados de conversión' },
  { key: 'capture:create', label: 'Capturar control de calidad' },
  { key: 'catalogs:manage', label: 'Gestionar catálogos' },
  { key: 'actions:manage', label: 'Gestionar acciones' },
  { key: 'sites:manage', label: 'Gestionar sitios' },
  { key: 'users:manage', label: 'Gestionar usuarios' },
  { key: 'permissions:view', label: 'Ver matriz de permisos' }
];

// Permissions per role. Use '*' for full access.
const ROLE_PERMISSIONS = {
  admin_master: ['*'],
  admin_site: [
    'dashboard:view',
    'reports:view',
    'conversion:view',
    'conversion:capture',
    'conversion:analytics',
    'conversion:reopen',
    'conversion:deleteReport',
    'conversion:employees',
    'conversion:automatic_report_viewanduse',
    'capture:create',
    'catalogs:manage',
    'actions:manage',
    'users:manage'
  ],
  admin_analytics: [
    'dashboard:view',
    'reports:view',
    'actions:manage'
  ],
  admin: [
    'dashboard:view',
    'reports:view',
    'actions:manage'
  ],
  analyst: [
    'dashboard:view',
    'reports:view',
    'actions:manage'
  ],
  operator: [
    'capture:create',
    'catalogs:manage'
  ],
  operator_conversion: [
    'conversion:view',
    'conversion:analytics',
    'conversion:capture'
  ],
  supervisor_conversion: [
    'conversion:view',
    'conversion:analytics',
    'conversion:reopen',
    'conversion:deleteReport',
    'conversion:employees',
    'conversion:ordersdata',
    'conversion:capture'
  ]
};

const PERMISSION_KEYS = PERMISSIONS.map((p) => p.key);

const getRolePermissionsMap = () => ROLE_PERMISSIONS;

const expandRolePermissions = (role) => {
  if (!role) return [];
  const rolePerms = getRolePermissionsMap()[role] || [];
  console.log('expandRolePermissions - role:', role, 'perms:', rolePerms);
  if (rolePerms.includes('*')) return PERMISSION_KEYS;
  return rolePerms;
};

const hasPermission = (role, permission) => {
  if (!permission) return true; // If no permission required, allow
  const rolePerms = getRolePermissionsMap()[role] || [];
  // Check for wildcard first
  if (rolePerms.includes('*')) {
    console.log('hasPermission - role:', role, 'permission:', permission, 'rolePerms:', rolePerms, 'has: true (wildcard)');
    return true;
  }
  const has = rolePerms.includes(permission);
  console.log('hasPermission - role:', role, 'permission:', permission, 'rolePerms:', rolePerms, 'has:', has);
  return has;
};

const hasAnyPermission = (role, permissions) => {
  if (!permissions || permissions.length === 0) return true;
  return permissions.some((perm) => hasPermission(role, perm));
};

export {
  PERMISSIONS,
  PERMISSION_KEYS,
  ROLE_PERMISSIONS,
  getRolePermissionsMap,
  expandRolePermissions,
  hasPermission,
  hasAnyPermission
};
